/** Body of POST projects/{id}/tasks/{taskId}/reopen. */
export class ProjectReopenRequestDTO {
  /**
   * ISO 8601. The completion stamp the client last read for that task. The server refuses with
   * PROJECT0001 when the task was completed again since; undefined skips the check.
   */
  expectedCompleted?: string;
}
